/**
 * One date/time format for the whole app — 24-hour, day-first, no AM/PM.
 *
 * Before this, the histogram rendered a tidy EU date while the sensor panel called
 * `toLocaleString(undefined, { hour: '2-digit' })`, which follows the BROWSER locale: an en-US
 * browser turned the same instant into "Aug 1, 03:24:11 PM" next to "01.08 15:24" (field report
 * 2026-08-03). Two clocks on one screen is how people misread a track.
 *
 * `undefined` locale is the bug — it hands the format to whatever the laptop is set to. We pin
 * `en-GB` (day-first, 24 h) and force `hour12: false`, so a boat's timestamp reads the same on
 * every machine, in the same order the crew says it out loud.
 */
const LOCALE = 'en-GB'

/** "01/08/2026, 15:24:11" — full stamp when the day matters. */
export const fmtDateTime = (ts: number): string =>
    new Date(ts).toLocaleString(LOCALE, {
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
    })

/** "1 Aug, 15:24:11" — compact stamp for panels where the year is obvious. */
export const fmtShortDateTime = (ts: number): string =>
    new Date(ts).toLocaleString(LOCALE, {
        day: 'numeric', month: 'short',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
    })

/** "15:24:11" — clock only, for scrubbers and axes inside one day. */
export const fmtClock = (ts: number): string =>
    new Date(ts).toLocaleTimeString(LOCALE, {
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
    })
